import styled from "styled-components"
import React, {FC} from "react"
import {DealType} from "@irati/types"
import tracking from "@irati-tracking/perks/perks"
import {Body, H3} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button/Button"
import Hero, {HeroSliderSettings} from "@irati/ui/src/Hero"
import Slider from "@irati/ui/src/Slider"
import Spacing from "@irati/ui/src/Spacing"
import FormattedMessage from "@irati/utils/lang"
import {RouterLink} from "@irati/ui/src/Link"
import outdoors from "./outdoors.jpg"
import tech from "./tech.jpg"
import travel from "./travel.jpg"
import fashion from "./fashion.jpg"

const Layout = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  height: 100%;

  padding: ${({theme}) => `${theme.spacing.four} ${theme.spacing.two}`};

  ${({theme}) => theme.mediaQueries.minWidthMedia.phoneLandscape`
    padding: ${theme.spacing.four} 0;
  `}
  max-width: 250px;

  & > * {
    color: ${({theme}) => theme.colors.greys.white};
  }
`

interface Props {
  onClick: () => void
  activeRegion?: string
}

interface Banner {
  img: string
  heading: string
  body: string
  type: DealType
  category: string
}

/**
 * Hardcoded banners
 * only used in certain hardcoded regions at this time
 * this is temporary, and will be updated to use our existing lanes tooling if the experiment drives more user purchases
 *
 * if you are reading this in 2024, PRODUCT LIED
 */
const banners: Banner[] = [
  {
    img: outdoors,
    heading: "perks.components.rewardBanner.outdoors.body",
    body: "perks.components.rewardBanner.outdoors.heading",
    type: DealType.Merchandise,
    category: "health-fitness"
  },
  {
    img: tech,
    heading: "perks.components.rewardBanner.tech.heading",
    body: "perks.components.rewardBanner.tech.body",
    type: DealType.Merchandise,
    category: "tech"
  },
  {
    img: travel,
    heading: "perks.components.rewardBanner.travel.heading",
    body: "perks.components.rewardBanner.travel.body",
    type: DealType.Merchandise,
    category: "travel"
  },
  {
    img: fashion,
    heading: "perks.components.rewardBanner.fashion.heading",
    body: "perks.components.rewardBanner.fashion.body",
    type: DealType.Merchandise,
    category: "shopping"
  }
]

const HeroReward: FC<Props> = ({onClick, activeRegion}) => (
  <>
    <Spacing marginTop={4} />
    <Slider slidesToShow={1} settings={HeroSliderSettings}>
      {banners.map(({img, heading, body, type, category}, i) => (
        <RouterLink
          key={i}
          scrollToTop={false}
          to={`/categories/${category}?type=${type.toLowerCase()}&regions=${activeRegion}`}
          onClick={() => {
            onClick()
            tracking.viewPromoBanner({
              bannerIndex: String(i),
              source: "Reward Catalogue Banner",
              perkType: type.toLowerCase(),
              perkCategory: category
            })
          }}>
          <Hero bgImg={img} bgPosition="right">
            <Layout>
              <H3 marginBottom={2}>
                <FormattedMessage id={heading} />
              </H3>
              <Body>
                <FormattedMessage id={body} />
              </Body>
              <div>
                <Button primary>
                  <FormattedMessage id="perks.components.rewardBanner.cta" />
                </Button>
              </div>
            </Layout>
          </Hero>
        </RouterLink>
      ))}
    </Slider>
    <Spacing marginTop={4} />
  </>
)

export default HeroReward
